<div class="detail-card">
  <div class="d-flex flex-column gap-1">
    <div class="title">{{ header }}</div>
    <div class="detail" i18n>
      Payment starts
      {{
        recurringPaymentForm?.controls?.paymentStartMonth?.value
          | vbPaymentStartDate : recurringPaymentForm?.controls?.paymentStartYear?.value
      }}
    </div>
  </div>

  <div class="d-flex flex-column gap-1 text-end">
    <div class="value">
      {{
        recurringPaymentForm?.controls?.paymentAmount?.value
          | recurringPaymentFrequency : recurringPaymentForm?.controls?.paymentFrequencyId?.value
      }}
    </div>
    <div *ngIf="!isMemberPortal" class="detail">
      {{ recurringPaymentForm?.controls?.recurringPaymentAmountType?.value | recurringPaymentAmountTypeName }}
    </div>
  </div>
</div>
